module.exports = __webpack_public_path__ + "static/media/right-top-img4.31b4b4a0.png";